import React from "react";
import { Col, Row, Card, CardBody, Button, CardText } from "reactstrap";
import manheimLogo from "assets/img/Manheim.svg";
import adesaLogo from "assets/img/adesa.png";
import carmaxLogo from "assets/img/carmaxauctions.svg";
import carvanaLogo from "assets/img/carvana.png";
import openLaneLogo from "assets/img/openLane.png";
import copartLogo from "assets/img/copart.svg";
import acvAuctionLogo from "assets/img/acvAuction.jpg";
import iaaAuctionLogo from "assets/img/iaaAuction.png";
const InventoryAuctionsTab = () => {
	return (
		<Row className="justify-content-center">
			<Col md={6} sm={6}>
				<div className="text-center">
					<Row>
						<Col md={3} sm={6} className="mb-3">
							<Card className="h-100">
								<CardBody className="d-flex flex-column mb-0">
									<img src={manheimLogo} alt="Manheim" className="mb-3" />
									{/* <CardText>
										Get wholesale auction access from Manheim, including live &
										Simulcast bidding, condition & recon reports, and more.{" "}
									</CardText> */}
									<div>
										<Button
											onClick={() => {
												window.open("https://site.manheim.com/");
											}}
											className="historyButtons zoom btn-primary"
										>
											Visit Website
										</Button>
									</div>
								</CardBody>
							</Card>
						</Col>
						<Col md={3} sm={6} className="mb-3">
							<Card className="h-100">
								<CardBody className="d-flex flex-column"></CardBody>
								<img src={adesaLogo} alt="ADESA" className="mb-3" />
								<div>
									<Button
										onClick={() => {
											window.open("https://www.adesa.com/");
										}}
										className="historyButtons zoom btn-primary"
									>
										Visit Website
									</Button>
								</div>
							</Card>
						</Col>
						<Col md={3} sm={6} className="mb-3">
							<Card className="h-100">
								<CardBody className="d-flex flex-column"></CardBody>
								<img src={carmaxLogo} alt="Carmax" className="mb-3" />
								<div>
									<Button
										onClick={() => {
											window.open("https://www.carmax.com/");
										}}
										className="historyButtons zoom btn-primary"
									>
										Visit Website
									</Button>
								</div>
							</Card>
						</Col>
						<Col md={3} sm={6} className="mb-3">
							<Card className="h-100">
								<CardBody className="d-flex flex-column"></CardBody>
								<img src={carvanaLogo} alt="Carmax" className="mb-3" />
								<div>
									<Button
										onClick={() => {
											window.open("https://carvanaauction.com/");
										}}
										className="historyButtons zoom btn-primary"
									>
										Visit Website
									</Button>
								</div>
							</Card>
						</Col>
						<Col md={3} sm={6} className="mb-3">
							<Card className="h-100">
								<CardBody className="d-flex flex-column"></CardBody>
								<img src={openLaneLogo} alt="OpenLane" className="mb-3" />
								<div>
									<Button
										onClick={() => {
											window.open("https://openlane.com/");
										}}
										className="historyButtons zoom btn-primary"
									>
										Visit Website
									</Button>
								</div>
							</Card>
						</Col>
						<Col md={3} sm={6} className="mb-3">
							<Card className="h-100">
								<CardBody className="d-flex flex-column"></CardBody>
								<img src={copartLogo} alt="Copart" className="mb-3" />
								<div>
									<Button
										onClick={() => {
											window.open("https://copart.com/");
										}}
										className="historyButtons zoom btn-primary"
									>
										Visit Website
									</Button>
								</div>
							</Card>
						</Col>
						<Col md={3} sm={6} className="mb-3">
							<Card className="h-100">
								<CardBody className="d-flex flex-column"></CardBody>
								<img src={acvAuctionLogo} alt="ACV Auction" className="mb-3" />
								<div>
									<Button
										onClick={() => {
											window.open("https://www.acvauctions.com/");
										}}
										className="historyButtons zoom btn-primary"
									>
										Visit Website
									</Button>
								</div>
							</Card>
						</Col>
						<Col md={3} sm={6} className="mb-3">
							<Card className="h-100">
								<CardBody className="d-flex flex-column"></CardBody>
								<img src={iaaAuctionLogo} alt="IAA Auction" className="mb-3" />
								<div>
									<Button
										onClick={() => {
											window.open("https://www.iaai.com/");
										}}
										className="historyButtons zoom btn-primary"
									>
										Visit Website
									</Button>
								</div>
							</Card>
						</Col>
					</Row>
				</div>
			</Col>
		</Row>
	);
};

export default InventoryAuctionsTab;
